export default {
  usd: '$',
  eur: '€',
};
